import React, { useRef } from "react";
import { TooltipContainer } from "@outplayed/tooltips";
import { useTranslation } from "react-i18next";
import { specTypeIdx } from "../../../hooks/path-hooks";
import DefaultSelect from "components/DefaultSelect";

const Spec = (props) => {
  const tooltipRef = useRef();
  const { t } = useTranslation();
  const { className, isMobile, disable, options, isDefault, onFilterChange, disableTooltip, selectedSpec } = props;

  if (disable && disable.includes("spec")) {
    return null;
  }

  const formatOptionLabel = ({ value, label, img }) => (
    <div className="class-option">
      {img ? (
        <img
          className="class-img"
          style={{ width: "25px", height: "25px", borderRadius: "50%", marginLeft: 1 }}
          src={img}
          alt={label}
        />
      ) : null}
      <span style={{ marginLeft: "10px" }}>{t(label)}</span>
    </div>
  );

  return (
    <TooltipContainer
      ref={tooltipRef}
      tooltipInfo={t("Change Spec")}
      customClassName={className}
      disableTooltip={isMobile || disableTooltip}
    >
      <div>
        <DefaultSelect
          title={t("Change Spec")}
          group={"spec"}
          isMobile={isMobile}
          className={`filter-select filter-select_class ${isDefault}`}
          options={options}
          onChange={(selected) => {
            onFilterChange("spec", selected.value, false, specTypeIdx);
          }}
          value={selectedSpec}
          formatOptionLabel={formatOptionLabel}
          width={170}
          isSearchable={false}
          onMenuClose={() => tooltipRef.current.forceClose()}
        />
      </div>
    </TooltipContainer>
  );
};

export default Spec;
